module.exports = __webpack_public_path__ + "static/img/njtc.d0e3e7a3.png";